/**
 * TanStack Query hooks for `localized-region-specific-dns-cdn-edge`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	localizedRegionSpecificDnsCdnEdgeQueryKeys,
	type CreateLocalizedRegionSpecificDnsCdnEdgeBody,
	type ListLocalizedRegionSpecificDnsCdnEdgeResponse,
	type LocalizedRegionSpecificDnsCdnEdgeRow,
} from "./api";

export function useLocalizedRegionSpecificDnsCdnEdgeList(): UseQueryResult<ListLocalizedRegionSpecificDnsCdnEdgeResponse, Error> {
	return useQuery({
		queryKey: localizedRegionSpecificDnsCdnEdgeQueryKeys.list(),
		queryFn: list,
	});
}

export function useLocalizedRegionSpecificDnsCdnEdgeCreate(): UseMutationResult<LocalizedRegionSpecificDnsCdnEdgeRow, Error, CreateLocalizedRegionSpecificDnsCdnEdgeBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: localizedRegionSpecificDnsCdnEdgeQueryKeys.all });
		},
	});
}

export function useLocalizedRegionSpecificDnsCdnEdgeDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: localizedRegionSpecificDnsCdnEdgeQueryKeys.all });
		},
	});
}
